/** Stable M1 ids; must agree with the database check and seed migration. */
export const MEMBER_ASSET_TYPE_IDS = {
    PLAYER: '00000000-0000-4000-8000-000000002101',
    TIMED: '00000000-0000-4000-8000-000000002102',
    Z: '00000000-0000-4000-8000-000000002103',
};
//# sourceMappingURL=member-point-type.js.map